import anime from 'animejs';

// component Loader
let componentLoader = document.getElementById("component-loader");

componentLoader.style.display = "flex";
componentLoader.style.opacity = .75;

componentLoader.style.opacity = 0;

// all animations
var show_ani;
var hide_ani;

// init all Anime.js animations
hide_ani = anime({
	easing: 'easeInOutQuart',
	duration: 250,
	targets: componentLoader,
	autoplay: false,
	
	opacity: [.7, 0],
	
	complete: function() {
		componentLoader.style.display = "none";
	},
});


show_ani = anime({
	easing: 'easeInOutQuart',
	duration: 250,
	targets: componentLoader,
	autoplay: false,
	
	opacity: [0, .7],
	
	begin: function() {
		componentLoader.style.display = "flex";
	},
});	


export function show() {
	show_ani.play();
}

export function hide() {
	hide_ani.play();
}